import { render } from "./NestedFormContainer.vue?vue&type=template&id=726f6972&ts=true"
import script from "./NestedFormContainer.vue?vue&type=script&lang=ts"
export * from "./NestedFormContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__